import React, { createContext } from "react";


export const VideoContext = createContext();

